export default function listingServices () {

	const containers = document.querySelectorAll('section.listing-services .cards');

	if (! containers.length) return;

	/*
		.title + .excerpt height varies per card (excerpt length differs), which
		pushes .variations down by different amounts even though the grid row
		itself is equal height (extra space just goes below .variations, before
		the mt-auto .btn) - not fixable with CSS alone since it needs the tallest
		title+excerpt of the row fed back in as every other card's own excerpt
		height. Grouped by visual row (via offsetTop) rather than the whole
		container, since each .cards grid can wrap to multiple rows at any
		breakpoint and only cards sharing a row need to match.
	*/
	// Matches --breakpoint-sm in tailwind.css - cards stack to a single column
	// below it, so there's no visual "row" to align across
	const aboveSm = window.matchMedia('(min-width: 768px)');

	function alignExcerpts () {
		containers.forEach(function (cards) {

			const items = [...cards.querySelectorAll(':scope > .card')];

			if (! items.length) return;

			// Reset first - re-runs (resize) need to measure natural heights, not
			// last run's padded ones, and below sm this is the only thing needed
			items.forEach(function (card) {
				const excerpt = card.querySelector('.excerpt');
				if (excerpt) excerpt.style.minHeight = '';
			});

			if (! aboveSm.matches) return;

			const rows = new Map();
			items.forEach(function (card) {
				const top = card.offsetTop;
				if (! rows.has(top)) rows.set(top, []);
				rows.get(top).push(card);
			});

			rows.forEach(function (rowCards) {

				if (rowCards.length < 2) return;

				let maxHeight = 0;
				rowCards.forEach(function (card) {
					const title = card.querySelector('.title');
					const excerpt = card.querySelector('.excerpt');
					if (! title || ! excerpt) return;
					maxHeight = Math.max(maxHeight, title.offsetHeight + excerpt.offsetHeight);
				});

				rowCards.forEach(function (card) {
					const title = card.querySelector('.title');
					const excerpt = card.querySelector('.excerpt');
					if (! title || ! excerpt) return;
					excerpt.style.minHeight = Math.max(maxHeight - title.offsetHeight, 0) + 'px';
				});

			});

		});
	}

	alignExcerpts();

	// Custom webfonts (title/excerpt) can finish loading after the initial measurement
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(alignExcerpts);
	}

	let resizeTimeout;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(alignExcerpts, 150);
	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=listing-services', listingServices);
}
